export default __webpack_public_path__ + "static/media/logo.440565e7.png";